/*
Copyright 2020 Adobe
All Rights Reserved.

NOTICE: Adobe permits you to use, modify, and distribute this file in
accordance with the terms of the Adobe license agreement accompanying
it. If you have received this file from a source other than Adobe,
then your use, modification, or distribution of it requires the prior
written permission of Adobe.
*/

import { AdobeDCNamespace, AdobeDCView, AdobeViewerConfig } from './interfaces';

declare global {
  interface Window {
    AdobeDC: AdobeDCNamespace;
  }
}

class ViewSDKClient {
  readyPromise: Promise<void>;

  adobeDCView: AdobeDCView | undefined;

  constructor() {
    this.readyPromise = new Promise<void>((resolve) => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener('adobe_dc_view_sdk.ready', () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
  }

  ready() {
    return this.readyPromise;
  }

  previewFile(
    divId: string,
    viewerConfig: AdobeViewerConfig,
    urlOrBuffer: string | ArrayBuffer,
    fileName: string,
  ) {
    const config: { clientId: string; divId: string } = {
      clientId: getClientId(),
      divId,
    };

    this.adobeDCView = new window.AdobeDC.View(config);

    const content =
      urlOrBuffer instanceof ArrayBuffer
        ? { promise: Promise.resolve(urlOrBuffer) }
        : { location: { url: urlOrBuffer } };

    return this.adobeDCView.previewFile(
      {
        content,
        metaData: {
          fileName,
          id: '6d07d124-ac85-43b3-a867-36930f502ac6',
        },
      },
      viewerConfig,
    );
  }
}

function getClientId() {
  if (window.location.origin.includes('localhost')) return '8c0cd670273d451cbc9b351b11d22318';
  if (window.location.origin.includes('dev.centerline.dev'))
    return '9932003700a44951b7e4203725240915';
  return '421bab5d220a49b4a01a58db6b793b86';
}

export default ViewSDKClient;
